export default "__VITE_ASSET__bd724400__"